import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { saveAssetPlanScenarioItems } from '#/graphql/mutations';
import type {
  SaveAssetPlanScenarioItemsMutation,
  SaveAssetPlanScenarioItemsMutationVariables,
} from '#/graphql/types';

const q = gql(saveAssetPlanScenarioItems);

interface SaveItemsParams {
  assetPlanScenarioId: string;
  items: SaveAssetPlanScenarioItemsMutationVariables['data']['items'];
}

const useSavePlanItemsMutation = () => {
  const [mutation, result] = useMutation<
    SaveAssetPlanScenarioItemsMutation,
    SaveAssetPlanScenarioItemsMutationVariables
  >(q);

  const saveItems = useCallback(
    async (params: SaveItemsParams) => {
      const response = await mutation({
        variables: {
          data: {
            assetPlanScenarioId: params.assetPlanScenarioId,
            items: params.items,
          },
        },
      });

      return response.data?.saveAssetPlanScenarioItems;
    },
    [mutation],
  );

  return { saveItems, result };
};

export default useSavePlanItemsMutation;
